var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cbox JobContainer"},[(_vm.code)?_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":_vm.url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }